<template>
  <div class="content">
    <Mobile ref="mobile" v-if="isMobile"></Mobile>
    <Desktop ref="desktop" v-else></Desktop>
    <div class="sidebar" :class="{'show': isSidebarOpen}">
      <div class="sidebar-overlay" @click="isSidebarOpen = false" />
      <div class="sidebar-inner">
        <div class="row">
          <div class="col-12 px-0">
            <ul class="nav nav-tabs nav-tabs-block nav-justified" role="tablist">
              <li class="nav-item">
                <a class="nav-link" :class="{active: sidebarTab === 'logs'}" @click="sidebarTab = 'logs'">
                  Logs
                </a>
              </li>
              <li v-if="model.hasSubstitutions" class="nav-item">
                <a class="nav-link" :class="{active: sidebarTab === 'substitutions'}" @click="sidebarTab = 'substitutions'">
                  Substitutions
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row h-100 overflow-y-auto pt-3 pb-5">
          <div class="col-lg-8 offset-lg-2 timeline-wrapper" v-if="sidebarTab === 'logs'">
            <ul class="timeline timeline-centered">
              <!-- Twitter Event -->
              <li
                v-for="gameLog in gameLogs" :key="gameLog.uuid"
                :data-testid="'live-log-' + gameLog.uuid"
                :class="{
                'timeline-event-alt': isLogSideAlt(gameLog),
                'reversed': reversedTeams
              }"
                class="timeline-event"
              >
                <div class="timeline-event-icon border border-info h-auto overflow-hidden">
                  <div class="bg-info">
                    {{ logScore(gameLog) }}
                  </div>
                  <div class="bg-light text-info flex flex-column py-1">
                    <span class="font-size-sm">
                      <span v-if="!config.scorekeeper_stopwatch_disabled" class="font-weight-bold mr-1">{{ gameLog.time }}</span>
                      <span style="font-size: 12px" v-if="gameLog.periodType === 'REGULAR'">P{{ gameLog.periodNumber }}</span>
                      <span style="font-size: 12px" v-if="gameLog.periodType === 'OVERTIME'">OT{{ gameLog.periodNumber }}</span>
                    </span>
                  </div>
                </div>
                <div class="timeline-event-block block js-appear-enabled animated fadeIn rounded"
                     data-toggle="appear">
                  <div class="block-header block-header-default px-1 py-1">
                    <div class="flex flex-grow-1">
                    <span class="text-white px-2 rounded ml-1" :style="{'background-color': gameLogColor(gameLog)}">
                    {{
                        $t('live.sports.' + config.sport + '.game_log_buttons.' + gameLog.relatedTo + '.' + gameLog.type)
                      }}</span>
                      <span class="m-0 w-100 ml-2" v-if="gameLog.team === model.homeTeam.uuid">{{
                          `${model.homeTeam.name}`
                        }}</span>
                      <span class="m-0 w-100 ml-2" v-else>{{ `${model.awayTeam.name}` }}</span>
                    </div>

                    <div class="block-options">
<!--                      <button @click="editLog(gameLog)" type="button" class="btn btn-info btn-sm mr-1">-->
<!--                        <i class="fa fa-pencil"></i>-->
<!--                      </button>-->
                      <button @click="deleteLog(gameLog.uuid)" type="button" class="btn btn-danger btn-sm" data-testid="live-log-delete">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <div class="block-content p-1">
                    <div><span
                      v-if="gameLog.relatedTo === 'player'"><span><strong class="font-size-h5 mx-2">#{{ gameLog.number_of_jersey }}</strong></span></span>
                      <span v-if="gameLog.relatedTo === 'player'">{{gameLog.playerOn.name}}</span>

                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="col-lg-8 offset-lg-2 timeline-wrapper" v-if="sidebarTab === 'substitutions'">
            <ul class="timeline">
              <li
                v-for="sub in substitutions" :key="sub.uuid"
                class="timeline-event"
              >
                <div class="timeline-event-icon border border-info h-auto overflow-hidden">
                  <div class="bg-info">
                    <i class="fa fa-exchange text-white"></i>
                  </div>
                  <div class="bg-light text-info flex flex-column py-1">
                    <span class="font-size-sm">
                      <span v-if="!config.scorekeeper_stopwatch_disabled" class="font-weight-bold mr-1">{{ sub.time }}</span>
                      <span style="font-size: 12px" v-if="sub.periodType === 'REGULAR'">P{{ sub.periodNumber }}</span>
                      <span style="font-size: 12px" v-if="sub.periodType === 'OVERTIME'">OT{{ sub.periodNumber }}</span>
                    </span>
                  </div>
                </div>
                <div class="timeline-event-block block js-appear-enabled animated fadeIn rounded"
                     data-toggle="appear">
                  <div class="block-header block-header-default px-1 py-1">
                    <div class="flex flex-grow-1">
                      <span class="text-white bg-primary px-2 rounded ml-1">Substitution</span>
                    </div>
                    <div class="block-options">
                      <button type="button" @click="editSubstitution(sub.uuid)" class="btn btn-info btn-sm mr-1">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button type="button" @click="deleteSubstitution(sub.uuid)" class="btn btn-danger btn-sm">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <div class="block-content p-2">
                    <div class="row">
                      <div class="col-12" v-if="sub.homeTeamPlayersIn.length || sub.homeTeamPlayersOut.length">
                        <h6 class="font-size-sm mb-1 text-primary">{{ model.homeTeam.name }}</h6>
                        <div class="mb-2">
                          <div v-for="p in sub.homeTeamPlayersIn" :key="'in-'+p.fullName" class="text-success font-size-sm">
                            <i class="fa fa-arrow-up mr-1"></i> #{{ p.jerseyNumber }} {{ p.fullName }}
                          </div>
                          <div v-for="p in sub.homeTeamPlayersOut" :key="'out-'+p.fullName" class="text-danger font-size-sm">
                            <i class="fa fa-arrow-down mr-1"></i> #{{ p.jerseyNumber }} {{ p.fullName }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="sub.awayTeamPlayersIn.length || sub.awayTeamPlayersOut.length">
                        <h6 class="font-size-sm mb-1 text-primary">{{ model.awayTeam.name }}</h6>
                        <div>
                          <div v-for="p in sub.awayTeamPlayersIn" :key="'in-'+p.fullName" class="text-success font-size-sm">
                            <i class="fa fa-arrow-up mr-1"></i> #{{ p.jerseyNumber }} {{ p.fullName }}
                          </div>
                          <div v-for="p in sub.awayTeamPlayersOut" :key="'out-'+p.fullName" class="text-danger font-size-sm">
                            <i class="fa fa-arrow-down mr-1"></i> #{{ p.jerseyNumber }} {{ p.fullName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <log-notifications
      class="notification-wrapper"
      group="logs"
      :max="4"
      position="bottom center">
        <template v-slot:body="props">
          <div class="notification-body d-flex justify-content-between align-items-center" style="background-color: #e6e6e6">
            <div class="d-flex align-items-center justify-content-between flex-grow-1">
              <div v-if="props.item.data.relatedTo === 'player'" class="d-flex align-items-center">
                <span class="mr-2">
                  <span style="font-size: 14px; color: #999999" class="mr-1">#</span><strong>{{props.item.data.number_of_jersey}}</strong>
                </span>
                <span style="font-size: 14px;" class="player-name">{{props.item.data.playerOn.name}}</span>
              </div>
              <div v-if="props.item.data.relatedTo === 'team'" class="d-flex align-items-center">
                <span style="font-size: 14px;" class="player-name" v-if="props.item.data.team === model.homeTeam.uuid">{{
                    `${model.homeTeam.name}`
                  }}
                </span>
                <span style="font-size: 14px;" class="player-name" v-if="props.item.data.team === model.awayTeam.uuid">{{
                    `${model.awayTeam.name}`
                  }}
                </span>
              </div>
              <span class="text-white badge badge-pill mr-1 log-type" :style="{'background-color': gameLogColor(props.item.data)}">
                {{$t('live.sports.' + config.sport + '.game_log_buttons.' + props.item.data.relatedTo + '.' + props.item.data.type)}}
              </span>
            </div>
            <button class="close" data-testid="live-log-undo" @click="deleteLogWithoutAsking(props)">
              <i class="fa fa-fw fa-trash text-danger"></i>
            </button>
          </div>

        </template>
    </log-notifications>
    <log-notifications
      class="notification-wrapper"
      group="deletedLogs"
      :max="2"
      position="top center">
      <template v-slot:body="props">
        <div class="notification-body deleted d-flex justify-content-between align-items-center flex-column" style="background-color: #e6e6e6">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div v-if="props.item.data.relatedTo === 'player'" class="d-flex align-items-center">
                <span class="mr-2">
                  <span style="font-size: 14px; color: #999999" class="mr-1">#</span><strong>{{props.item.data.number_of_jersey}}</strong>
                </span>
              <span style="font-size: 14px;" class="player-name">{{props.item.data.playerOn.name}}</span>
            </div>
            <div v-if="props.item.data.relatedTo === 'team'" class="d-flex align-items-center">
                <span style="font-size: 14px;" class="player-name" v-if="props.item.data.team === model.homeTeam.uuid">{{
                    `${model.homeTeam.name}`
                  }}
                </span>
              <span style="font-size: 14px;" class="player-name" v-if="props.item.data.team === model.awayTeam.uuid">{{
                  `${model.awayTeam.name}`
                }}
                </span>
            </div>
            <span class="text-white badge badge-pill mr-1 log-type" :style="{'background-color': gameLogColor(props.item.data)}">
                {{$t('live.sports.' + config.sport + '.game_log_buttons.' + props.item.data.relatedTo + '.' + props.item.data.type)}}
              </span>
          </div>
        </div>

      </template>
    </log-notifications>
  </div>
</template>
<script>

import Desktop from '@/views/live/desktop/Desktop.vue'
import GameService from '@/services/game.service'
import router from '@/router'
import store from '@/store'
import Mobile from '@/views/live/mobile/Mobile.vue'
import VueI18n from '@/i18n'
import { useLive } from '@/views/live/use/useLive'

export default {
  components: {
    Mobile,
    Desktop
  },
  setup () {
    const live = useLive()

    return {
      live,
      ...live,
      model: live.model,
      config: live.config
    }
  },
  data () {
    return {
      isMobile: false
    }
  },
  created () {
    this.checkIfMobile()
    window.addEventListener('resize', this.checkIfMobile)
  },
  mounted () {
    this.onInit()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkIfMobile)
  },
  destroyed () {
    this.onDestroy()
  },
  computed: {
    reversedTeams () {
      return this.$store.state.main.reversedTeams
    }
  },
  methods: {
    isLogSideAlt (gameLog) {
      return this.reversedTeams ? (gameLog.team !== this.model.awayTeam.uuid) : (gameLog.team === this.model.awayTeam.uuid)
    },
    logScore (gameLog) {
      if (this.reversedTeams) {
        return `${gameLog.away_team_score} : ${gameLog.home_team_score}`
      }

      return `${gameLog.home_team_score} : ${gameLog.away_team_score}`
    },
    deleteLog (uuid) {
      GameService.deleteLog(uuid)
    },
    deleteLogWithoutAsking (props) {
      GameService.deleteLogWithoutAsking(props.item.data.uuid)
      props.close()
    },
    deleteSubstitution (uuid) {
      GameService.deleteSubstitution(uuid)
    },
    editSubstitution (uuid) {
      this.live.editSubstitution(uuid)
    },
    translateLog (gameLog) {
      if (gameLog.against === null && gameLog.teammate === null) {
        return VueI18n.t('live.sports.' + this.config.sport + '.logs.' + gameLog.relatedTo + '.' + gameLog.type + '.alone', [gameLog.on])
      } else {
        if (gameLog.against !== null) {
          return VueI18n.t('live.sports.' + this.config.sport + '.logs.' + gameLog.relatedTo + '.' + gameLog.type + '.against', [gameLog.on, gameLog.against])
        } else if (gameLog.teammate !== null) {
          return VueI18n.t('live.sports.' + this.config.sport + '.logs.' + gameLog.relatedTo + '.' + gameLog.type + '.teammate', [gameLog.on, gameLog.teammate])
        }
      }
    },
    checkIfMobile () {
      this.isMobile = window.innerWidth <= 600
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!store.getters.isAdminOrInternalScorekeeper && !store.getters.isExternalScorekeeper) {
      return next('/')
    }
    GameService.status().then((response) => {
      if (response.data === 'SCHEDULED') {
        router.push({ name: 'preGame' })
      } else if (response.data === 'FINISHED') {
        router.push({ name: 'archive' })
      } else if (response.data === 'LIVE') {
        GameService.live().then((response) => {
          next(vm => vm.$store.dispatch('main/setModel', response.data))
        })
      }
    }).catch(() => {
      //
    })
  }
}
</script>
